import React from 'react';
import { Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import moment from 'moment';
import intl from 'react-intl-universal';

import { DATE_TIME_FORMAT } from '@/config';
import { getTimeByUtcOffset } from '@/utils/intl';
import { takeCareMap } from '../../helper';

const HistoryTabItem = ({ list, loading }) => {
  const columns: ColumnsType<any> = [
    {
      title: intl.get('roomstate_take_care_record_column_crate_time'),
      dataIndex: 'createTime',
      render: (val) => (val ? getTimeByUtcOffset(val, DATE_TIME_FORMAT) : ''),
    },
    { title: intl.get('roomstate_take_care_record_column_crate_user'), dataIndex: 'createBy' },
    {
      title: intl.get('roomstate_take_care_table_column_task_status'),
      dataIndex: 'acStatus',
      render: (val) => takeCareMap[val],
    },
    { title: intl.get('roomstate_take_care_table_column_task_content'), dataIndex: 'content' },
    {
      title: intl.get('app_reservation_eta_time'),
      dataIndex: 'expectedArrivalTime',
      render: (val) => (val ? getTimeByUtcOffset(val, DATE_TIME_FORMAT) : ''),
    },
    {
      title: intl.get('app_reservation_checkin_remark'),
      dataIndex: 'checkRemark',
      render: (val) => val || '-',
    },
  ];

  return (
    <>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={list}
        loading={loading}
        pagination={false}
        scroll={{ x: 'max-content' }}
      />
    </>
  );
};

export default HistoryTabItem;
